import React from "react";
import PropTypes from "prop-types";
import { Button } from "antd";
import { BellOutlined } from "@ant-design/icons";

const NotifyButton = ({ disabled }) => {
  return (
    <>
      <Button className="notify-button" disabled={disabled}>
        <BellOutlined />
        NOTIFY
      </Button>
    </>
  );
};

NotifyButton.propTypes = {
  disabled: PropTypes.bool,
};

export default NotifyButton;
